<script type="ts">
    export let href: string;
    export let full: boolean = false;
    export let color: "primary" | "secondary" = "secondary";
    export let plain: boolean = false;
    export let border: boolean = true;
    export let ariaLabel: string = "";
    let className = "block text-center transition rounded-lg";
    className += full ? " w-full" : " w-fit";
    className += plain
        ? " hover:bg-transparent" +
          (color === "primary" ? " bg-primary" : " bg-secondary") +
          (color === "primary"
              ? " hover:text-primary"
              : " hover:text-secondary") +
          (color === "primary" ? " text-secondary" : " text-primary")
        : border &&
          (color === "primary" ? " hover:bg-primary" : " hover:bg-secondary") +
              " bg-transparent" +
              (color === "primary"
                  ? " hover:text-primary"
                  : " hover:text-secondary");
    className += border
        ? " border p-4" +
          (color === "primary" ? " border-primary" : " border-secondary")
        : " p-2" + (color === "primary"
        ? " hover:bg-primary/25"
        : " hover:bg-secondary/25");
</script>

<a {href} class={className} aria-label={ariaLabel}>
    <slot />
</a>
